import webinsService from "@/services/WebinsService";
import { AvailabilityResponse } from "@/services/responses/AvailabilityResponse";
import { ref, watch, computed, defineComponent } from "vue";
import { useWidget } from "./useWidget";
import { useI18n } from 'vue-i18n';
import { ParametriPreventivatoreItem } from "@/models/ParametriPreventivatore";
import { AssociaDistributoriPacchettiExtended, gruppoSchedaProdottoParametri } from "@/models/AssociaDistributoriPacchetti";
import { totaliCarrello } from "@/models/TotaliCarrello";
import { RigaCarrelloDati, RigaCarrello } from "@/models/RigaCarrello";
import { RispostaAdesioneMultipla, RispostaAdesione, RispostaAdesioneWidget, RispostaAdesioneMultiplaWidget } from "@/models/RispostaAdesioneMultipla";

const loading = ref(false);
const msgAddToCart = ref("");
const risultatiPreventivatore = ref<AssociaDistributoriPacchettiExtended[]>([]);
const services = ref<AvailabilityResponse[]>([]);

const parametriPreventivatore = ref<ParametriPreventivatoreItem>( new ParametriPreventivatoreItem() );
const parametriSchedaPreventivatore = ref<gruppoSchedaProdottoParametri[]>( [] );
const rigaCarrelloDati = ref<RigaCarrelloDati>(null);
const totali = ref<totaliCarrello>(null);
const transazione = ref<RispostaAdesioneMultipla>(null);
const adesioneCreata = ref<RispostaAdesione>(null);
const guidAdesioneSearch = ref<string>(null);



export function usePolizze() {
    const { fetchData, options } = useWidget();
    const { t } = useI18n();

    //adesioneCreata.value = JSON.parse('{"result":"ok","pdfCompleto":"/adesioni/file?id=f9cd4345-c246-4dc2-ae4e-6ead11176f3f","pdfElenco":["/file/adesione/f9cd4345-c246-4dc2-ae4e-6ead11176f3f/PDF Copertura_C000.pdf"],"guidAdesione":"f9cd4345-c246-4dc2-ae4e-6ead11176f3f","numeroAdesione":938477,"redirecUrl":null,"keyClientInfo":null,"datiAdesione":{"itemID":938477,"itemGUID":"f9cd4345-c246-4dc2-ae4e-6ead11176f3f","userId":null,"wI_ItemID":null,"pacchettoID":94,"numeroPartecipanti":2,"inizioViaggio":"2023-11-10T15:53:08.173+01:00","fineViaggio":"2023-11-10T15:53:08.173+01:00","durataViaggio":1,"destinazioneAlpha3":"ALB","destinazioneID":253,"nazionalitaID":1,"importoViaggio":0.0,"praticheComplementari":"","note":null,"riferimentoPratica":null,"chkIVASS":true,"chkTermini":true,"chkPrivacy":true,"chkCommerciale":true,"datiAggiuntivi":null,"totalePremio":100.00,"totalePremioNetto":94.12,"totalePremioImposte":5.88,"totalePremioPersona":50.00,"totalePremioPersonaImposte":2.94,"commissioni":18.82,"totalePremioDaPagare":81.18,"istanteInserimento":"2023-11-10T16:12:42.17+01:00","contrattoNumero":"T001/2017","nazionalita":"Italia","destinazione":"Albania","gruppoStati":"Europa, Bacino e Mondo","pdfCopertura":"/adesioni/file?id=f9cd4345-c246-4dc2-ae4e-6ead11176f3f","numeroAdesione":938477,"fileInvioOnlineID":10,"codiceRiepilogo":"Mondo","fileInvioOnLIne":"IMA","pacchetto":"Easy 250 e In viaggio con te","importoSconto":null,"importoPagato":null,"dataPagamento":null,"contraenteID":4,"utente":null,"distributore":"B&T INSURANCE SERVICE Srl","codiceRaggruppamento":"xxx","codiceTariffa":null,"distributoreID":5,"tipoDistributore":null,"estrattoContoID":null,"dataModifica":null,"fornitoreID":6,"dataInserimento":"2023-11-10T00:00:00+01:00","codiceCoupon":null,"codiceRiepilogoOnline":"Mondo","numeroCompleto":"2023111093847712","imageElenco":null,"imageFilePartecipanti":null,"numeroAlloggi":0,"secondoImporto":0.0,"recuperoCredito":null,"isOld":false,"acquistataConCredito":null,"partecipantiElencoLista":[{"itemID":1,"cognome":"Rossi","nome":"Mario","codiceFiscale":"123","dataNascita":"1970-01-01T01:00:00+01:00"},{"itemID":2,"cognome":"Bianchi","nome":"Luigi","codiceFiscale":"","dataNascita":"1970-03-01T01:00:00+01:00"}]},"codeResult":null,"errorObject":null}');

    const getPreventivatore = async ( parametri: ParametriPreventivatoreItem) => {

        parametriPreventivatore.value = parametri;

        if(options.value.prodotti && options.value.prodotti.length){
            //parametri.prodottiSelezionati = options.value.prodotti;
        }
        
        const retPreventivatore = await fetchData(loading, webinsService.preventivatore(parametri));
        risultatiPreventivatore.value = retPreventivatore;
    }

    const getParametriSchedaPreventivatore = async () => {

        const retSchedaPreventivatore = await fetchData(loading, webinsService.getParametriProdotti());
        parametriSchedaPreventivatore.value = retSchedaPreventivatore;
    }

    const getSuggerimentiPolizza = async (parametri: ParametriPreventivatoreItem, pacchettoID: number) => {

        const suggerimenti = await fetchData(loading, webinsService.getSuggerimentiPolizza(parametri, pacchettoID));
        return suggerimenti;
    }

    const getTotaliPolizza = async (rigaCarrello: RigaCarrello) => {

        const tot  = await fetchData(loading, webinsService.getTotaliCarrello(rigaCarrello));
        totali.value = tot;
        return tot;
    }

    const setRigaCarrello = async (r: RigaCarrelloDati) => {
        rigaCarrelloDati.value = r;
    }

    const acquista = async (r: RigaCarrello, widgetCode: string) : Promise<RispostaAdesioneMultipla> => {
        r.widgetCode = widgetCode
        const resAcquisto  = await fetchData(loading, webinsService.acquista(r));
        transazione.value = resAcquisto;
        return resAcquisto;
    }

    

    const finalizzaTransazione = async () : Promise<RispostaAdesione> => {
        if(!transazione.value || !transazione.value.transactionID)
            transazione.value =  {transactionID: "46J34731W50082101£",redirecUrl: "", adesioni: [], adesioniErrori: []};
            // return null;

        debugger

        const resAcquisto  = await fetchData(loading, webinsService.finalizzaTransazione(transazione.value.transactionID));
        if(resAcquisto)
            adesioneCreata.value = resAcquisto;
        return resAcquisto;
    }

    
    const notificaPagamentoAnnullato = async () : Promise<RispostaAdesione> => {
        if(!transazione.value || !transazione.value.transactionID)
            return null;

        debugger

        const resNotifica  = await fetchData(loading, webinsService.notificaPagamentoAnnullato(transazione.value.transactionID));
        return resNotifica;
    }

    const aggiungiACarrello = async (r: RigaCarrello, widgetCode: string) : Promise<RispostaAdesioneMultiplaWidget> => {
        r.widgetCode = widgetCode
        const resAcquisto  = await fetchData(loading, webinsService.aggiungiACarrello(r));
        transazione.value = resAcquisto;
        return resAcquisto;
    }



    const caricaAdesione = async (guidAdesione: string, emailAssociata: string) : Promise<RispostaAdesioneWidget> => {

        const res  = await fetchData(loading, webinsService.caricaAdesione(guidAdesione, emailAssociata));

        adesioneCreata.value = res;

        if(res){
            rigaCarrelloDati.value = {
                datiCarrello: (adesioneCreata.value.datiAdesione as any ) as RigaCarrello,
                datiProdotto: res.datiProdotto
            }

            totali.value = res.totali;

        }

        return res;
    };

    

    const numberToPercentage = ( value : string, decimalPlaces?: number  ) => {
        return new Intl.NumberFormat('it-IT', {
            style: 'percent',
            minimumFractionDigits: decimalPlaces || 2,
            maximumFractionDigits: decimalPlaces || 2,
          }).format(parseFloat(value ||"0") / 100);
    }

    const numberToCurrency = ( value : string, decimalPlaces?: number  ) => {
        return new Intl.NumberFormat('it-IT', {
            style: 'currency',
            currency: "EUR",
            minimumFractionDigits: decimalPlaces == null ? 2 : decimalPlaces
          }).format(parseFloat(value ||"0"));
    }

    const numberToDecimal = ( value : string, decimalPlaces?: number  ) => {
        return new Intl.NumberFormat('it-IT', {
            minimumFractionDigits: decimalPlaces || 2,
            maximumFractionDigits: decimalPlaces || 2,
          }).format(parseFloat(value ||"0"));
    }

    const numberToInteger = ( value : string ) => {
        return new Intl.NumberFormat('it-IT', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
          }).format(parseFloat(value ||"0"));
    }

    const getTerminiECondizioni = (prod: AssociaDistributoriPacchettiExtended) => {
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            webinsService
            .getTerminiECondizioni(prod.pacchettoID, prod.prodottoID)
            .then((res) => {
                const blob = new Blob([(res as any).data], { type: (res as any).headers["content-type"] });
                
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any).msSaveOrOpenBlob(blob);
                } else {
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, "_blank");
                }
            })
            .catch((err) => {
                alert("File non trovato");
            });

        }
        else{
            const url = webinsService.baseUrl + `/terminiecondizioni?pacchettoId=${prod.pacchettoID}&prodottoId=${prod.prodottoID}`;
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const getDocumentoPolizza = (prod: AssociaDistributoriPacchettiExtended, tipoDoc: number) => {
        debugger
        if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            webinsService
            .getDocumentoPolizza(prod.pacchettoID, prod.prodottoID, tipoDoc)
            .then((res) => {
                const blob = new Blob([(res as any).data], { type: (res as any).headers["content-type"] });
                
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any).msSaveOrOpenBlob(blob);
                } else {
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, "_blank");
                }
            })
            .catch((err) => {
                alert("File non trovato");
            });

        }
        else{
            const url = webinsService.baseUrl + `/documentoPolizza?pacchettoId=${prod.pacchettoID}&prodottoId=${prod.prodottoID}&tipoDocumento=${tipoDoc}`;
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    


    const downloadCertificato = (guidAdesione: string) => {

        //if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
            webinsService
            .downloadAdesione(guidAdesione)
            .then((res) => {
                const blob = new Blob([(res as any).data], { type: (res as any).headers["content-type"] });
                
                if (window.navigator && (window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any).msSaveOrOpenBlob(blob);
                } else {
                    const fileURL = URL.createObjectURL(blob);
                    window.open(fileURL, "_blank");
                }
            })
            .catch((err) => {
                alert("File non trovato");
            });

       /* }
        else{
            const url = webinsService.baseUrl + `/terminiecondizioni?pacchettoId=${prod.pacchettoID}&prodottoId=${prod.prodottoID}`;
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }*/
    };


    const testGetDatiAdesione = async (guidAdesione: string) : Promise<RispostaAdesione> => {

        const res = await webinsService.testGetDatiAdesione(guidAdesione);
        adesioneCreata.value = res;
        return res;
    };
    
    


    return { 
        loading, services,
        getPreventivatore, getParametriSchedaPreventivatore, risultatiPreventivatore, getSuggerimentiPolizza, getTotaliPolizza,
        getTerminiECondizioni, getDocumentoPolizza, setRigaCarrello, acquista, finalizzaTransazione, notificaPagamentoAnnullato,  downloadCertificato, testGetDatiAdesione,
        numberToPercentage, numberToCurrency, numberToDecimal, numberToInteger,
        aggiungiACarrello, caricaAdesione, 
        parametriPreventivatore, parametriSchedaPreventivatore, totali, rigaCarrelloDati, transazione, adesioneCreata, guidAdesioneSearch,
        msgAddToCart
    }
}